import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useDocumentMeta } from '../lib/seo';
import { Spinner } from '../components/Primitives';

export function Book() {
  useDocumentMeta(
    'Book an Appointment | Nine80 Hair Studio',
    'Book an appointment at Nine80 Hair Studio via Booksy.',
  );
  const [url, setUrl] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    api
      .booksyUrl()
      .then((res) => {
        if (!cancelled) setUrl(res.url);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="mx-auto max-w-2xl px-4 py-16 text-center space-y-6">
      <h1 className="text-4xl">Book an Appointment</h1>
      <p className="text-fg-muted text-lg">
        Appointments at Nine80 Hair Studio are booked through Booksy, separate from our walk-in
        list.
      </p>

      {url === undefined && (
        <div className="flex justify-center py-6 text-primary">
          <Spinner className="h-6 w-6" />
        </div>
      )}

      {url === null && (
        <p className="text-fg-muted">
          Online booking isn't set up yet — please call{' '}
          <a href="tel:+19802558167" className="text-primary hover:underline">
            (980) 255-8167
          </a>{' '}
          to schedule an appointment.
        </p>
      )}

      {url && (
        <a
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          className="btn-primary text-lg px-8"
        >
          Book on Booksy
        </a>
      )}

      <div>
        <Link to="/check-in" className="text-sm text-primary hover:underline">
          Or join the walk-in list instead →
        </Link>
      </div>
    </div>
  );
}
